import '@tamagui/core/reset.css'
import { BRAND_TEAL } from '@buyerflo/core/tamagui/theme'
import { ClerkProvider, useUser } from '@clerk/react'
import { APIProvider } from '@vis.gl/react-google-maps'
import AppRoutes from 'AppRoutes'
import { SnackbarProvider } from 'components/snackbar'
import { useEffect } from 'react'
import { TamaguiProvider, Theme } from 'tamagui'
import { ColorSchemeProvider, useColorScheme } from './colorScheme'
import posthog from './lib/posthog'
import { AppTRPCProvider } from './providers/trpcProvider'
import config from './tamagui.config'

const { VITE_CLERK_PUBLISHABLE_KEY, VITE_GOOGLE_MAPS_API_KEY } = import.meta.env

function AppInner() {
    const { resolvedScheme } = useColorScheme()

    return (
        <TamaguiProvider
            config={config}
            defaultTheme={resolvedScheme}
        >
            <Theme name={resolvedScheme}>
                <SnackbarProvider>
                    <AppRoutes />
                </SnackbarProvider>
            </Theme>
        </TamaguiProvider>
    )
}

function PostHogIdentify() {
    const { user, isSignedIn } = useUser()

    useEffect(() => {
        if (isSignedIn && user) {
            posthog.identify(user.id, {
                email: user.primaryEmailAddress?.emailAddress,
                name: user.fullName,
            })
        } else if (!isSignedIn) {
            posthog.reset()
        }
    }, [isSignedIn, user])

    return null
}

function App() {
    return (
        <ClerkProvider
            publishableKey={VITE_CLERK_PUBLISHABLE_KEY}
            appearance={{
                variables: {
                    fontFamily:
                        '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                    colorPrimary: BRAND_TEAL,
                },
            }}
        >
            <PostHogIdentify />
            <AppTRPCProvider>
                <APIProvider
                    apiKey={VITE_GOOGLE_MAPS_API_KEY}
                    libraries={['places', 'geocoding']}
                >
                    <ColorSchemeProvider>
                        <AppInner />
                    </ColorSchemeProvider>
                </APIProvider>
            </AppTRPCProvider>
        </ClerkProvider>
    )
}

export default App
